import script from "./blog-details.vue?vue&type=script&setup=true&lang=js"
export * from "./blog-details.vue?vue&type=script&setup=true&lang=js"

import "./blog-details.vue?vue&type=style&index=0&id=732dd0ac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-732dd0ac"]])

export default __exports__